import type { LogtoConfig } from "@logto/react";

export const authConfig: LogtoConfig = {
  endpoint: "https://auth.everbay.de/",
  appId: "lnMAq3onT83h93P94AiLm",
  resources: ["https://api.gowoop.de", "https://backend.gowoop.de"],
  scopes: [
    "email",
    "custom_data",
    "read:user",
    "write:user",
    "update:user",
    "delete:user",
  ],
};
